export default {
  username: '用户名',
  password: '密码',
  rememberPwd: '记住密码',
  submit: '登录',
  usernameRequired: '请输入用户名',
  passwordRequired: '请输入密码',
}
